<template>
  <l-autocomplete
    v-model="model"
    v-model:query="query"
    v-bind="{ items }"
    links
  >
    <template #append-item="{ item }">
      <icon
        v-if="item.starred"
        name="fa-star"
        set="solid"
        color="yellow"
      />
    </template>
  </l-autocomplete>
</template>

<script setup>
import Icon from "@/components/Icon.vue"
import LAutocomplete from "@/components/inputs/LAutocomplete.vue"
import { computed, ref } from "vue"
import { useSchools } from "@/composables/useSchools"
import { useStates } from "@/composables/useStates"

const model = defineModel([Object, String])

const query = ref("")

const { schools } = useSchools()
const { states } = useStates()

const stateItems = computed(() => states.map(state => ({
  ...state,
  icon: "location",
  starred: state.is_preferred,
})))

const schoolItems = computed(() => schools.map(school => ({
  ...school,
  icon: "school",
  starred: school.in_list,
})))

const items = computed(() => (
  query.value.length
    ? [...stateItems.value, ...schoolItems.value]
    : [...schoolItems.value, ...stateItems.value]
))
</script>
